import { baseStyles } from '../base-styles';

export function getStyles(accent: string, _position: string): string {
  return baseStyles(accent) + `
    .yd-bar-trigger {
      position: fixed;
      bottom: 0;
      left: 0;
      right: 0;
      height: 48px;
      background: #ffffff;
      border: none;
      border-top: 3px solid ${accent};
      box-shadow: 0 -2px 8px rgba(0,0,0,0.08);
      display: flex;
      align-items: center;
      padding: 0 20px;
      gap: 12px;
      cursor: pointer;
      z-index: 1;
      pointer-events: auto;
      font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
      transition: box-shadow 0.2s;
    }
    .yd-bar-trigger:hover {
      box-shadow: 0 -4px 16px rgba(0,0,0,0.12);
    }

    .yd-bar-name {
      font-size: 13px;
      font-weight: 600;
      color: #1f2937;
      white-space: nowrap;
    }

    .yd-bar-placeholder {
      flex: 1;
      font-size: 13px;
      color: #9ca3af;
      text-align: center;
    }

    .yd-bar-icon {
      display: flex;
      align-items: center;
      flex-shrink: 0;
    }

    @keyframes yd-slide-up {
      from { transform: translateX(-50%) translateY(100%); opacity: 0; }
      to   { transform: translateX(-50%) translateY(0);   opacity: 1; }
    }

    .yd-bar-panel {
      position: fixed;
      bottom: 0;
      left: 50%;
      transform: translateX(-50%);
      width: 100%;
      max-width: 600px;
      max-height: 520px;
      background: #fff;
      border-radius: 16px 16px 0 0;
      box-shadow: 0 -4px 32px rgba(0,0,0,0.14);
      display: flex;
      flex-direction: column;
      overflow: hidden;
      z-index: 1;
      font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
      pointer-events: auto;
      animation: yd-slide-up 0.28s cubic-bezier(0.25, 0.46, 0.45, 0.94) both;
    }

    @media (max-width: 480px) {
      .yd-bar-panel {
        max-height: 100vh;
        height: 100vh;
        border-radius: 0;
        top: 0;
        max-width: 100%;
      }
    }
  `;
}
